export default {
    button_request_permission: 'Allow',
    default_notification: {
        title: 'New Notification!',
        text: 'You have received a new notification, click here to view',
    },
    notification_permissions: {
        allow: {
            title: 'Allow Notifications',
            text: `Some system functionality uses browser notifications.\nPlease allow the system to send notifications.`,
        },
        denied: {
            title: 'Blocked Notifications',
            text: 'We have identified that you have denied access to notifications and some functionality may not work.\n'+
                'Please allow the system to send notifications by clicking the icon on the left or right side of the navigation bar \n' +
                'where the address https://app.taskier.io appears in your browser and reload the page.',
        },
        noSupport: {
            title: 'Browser not Supported',
            text: 'This browser does not support notifications and some features of the system may not work properly',
        },
        braveBlocked: {
            title: 'Brave Browser',
            text: 'Your browser is probably blocking you from receiving push notifications.' +
                '\nTo unlock please open a new tab, enter the link "brave://settings/privacy" and enable the option "Use Google services to receive push messages"',
        },
    },
    service_chat: {
        answer: {
            title: 'Chat Request',
            text: 'The customer {{name}} is waiting for service in the chat',
        },
        accept_transfer: {
            title: 'Chat Transfer Request',
            text: 'User {{agent}} is transferring customer chat {{customer}}',
        },
    },
}
